import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLocalPackageBooking,
  getLocalPriceCode,
  getUserData,
  setLocalPackageBooking,
  setLocalPriceCode,
} from "../../utils/localStorage";
import {
  getStoreDefaultPrice,
  packageBooking,
} from "../../services/BookNewOrder/BookNewOrder";
import PackageBookingPackageSelection from "./PackageBookingPackageSelection";
import { getPriceCode } from "../../services/StorePriceCode/getPriceCode";
import GeneralBookingPriceListSelection from "./GeneralBookingPriceListSelection";
import PriceCodeNotFound from "./PriceCodeNotFound";
import CustomerPackagesModal from "../CartComponent/CustomerPackagesModal";

const { innerWidth: width, innerHeight: height } = window;

const BookNewOrder = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { storeCustomerId, customerData, packageBookingModal, navigateThrough } =
    location.state || {}; // Fallback to prevent undefined errors
  const { storeData, userProfileRole, brandProfileData, userProfileData } =
    getUserData();
  const storeId = storeData.id;
  const userRole = userProfileRole;
  const enabledMultiPriceList = storeData.enabledMultiPriceList;
  const storeCarryForward = storeData.packageCarryForward;
  const brandCarryForward = brandProfileData.packageCarryForward;
  const brandId = userProfileData.brandId;
  const brandCarryForwardApplyOn = brandProfileData.carryForwardApplyOn;

  const [defaultPriceData, setDefaultPriceData] = useState({});
  const [packageData, setPackageData] = useState([]);
  const [packageBookingModalVisible, setPackageBookingModalVisible] =
    useState(false);
  const [
    generalBookingPriceListModalVisible,
    setGeneralBookingPriceListModalVisible,
  ] = useState(false);

  const [priceCodeModalVisible, setPriceCodeModalVisible] = useState(false);
  const [customerPackagesModalVisible, setCustomerPackagesModalVisible] = useState(false)

  // const fetchDefaultPrice = () => {
  //   // getStoreDefaultPrice(storeId)
  //   getPriceCode(storeId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const Res = response.data;
  //         setDefaultPriceData(Res.storePrices);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  const fetchDefaultPrice = async () => {
    try {
      const response = await getPriceCode(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setDefaultPriceData(Res.storePrices);
        setLocalPriceCode(Res.storePrices);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalDefaultPrice = async () => {
    const { priceCode } = getLocalPriceCode();
    if (priceCode && Object.keys(priceCode).length > 0) {
      setDefaultPriceData(priceCode);
    } else {
      await fetchDefaultPrice();
    }
  };

  const fetchPackage = async () => {
    try {
      const response = await packageBooking(storeId);
      if (!response.data.error) {
        setPackageData(response.data);
        setLocalPackageBooking(response.data);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalPackage = async () => {
    const { packageBooking } = getLocalPackageBooking();
    if (packageBooking && Object.keys(packageBooking).length > 0) {
      setPackageData(packageBooking);
    } else {
      await fetchPackage();
    }
  };

  // const fetchPackage = () => {
  //   packageBooking(storeId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         setPackageData(response.data);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  useEffect(() => {
    if (packageBookingModal === true) {
      handleSelectYourPackage();
    }
  }, [packageBookingModal]);

  useEffect(() => {
    // fetchDefaultPrice();
    fetchLocalDefaultPrice();
    // fetchPackage();
    fetchLocalPackage();
  }, []);

  const receiveSelectedPackageData = ({ item }) => {
    bookOrderNow(item.price.id, "PackageBooking");
  };

  const handleSelectYourPackage = () => {
    setPackageBookingModalVisible(true);
  };

  const receiveSelectedPriceListData = ({ item }) => {
    bookOrderNow(item.price.id, "GeneralBooking");
  };

  const handleSelectYourPriceList = () => {
    setGeneralBookingPriceListModalVisible(true);
  };

  const handleBackButton = () => {
    if (userRole === "BY_STORE" && navigateThrough == "partialBooking") {
      navigate("/store-partial-booking");
    } else if (userRole === "BY_STORE") {
      navigate("/CustomerInfo", {
        state: {
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const bookOrderNow = (priceId, componentName) => {
    navigate("/GeneralBookingSelection", {
      state: {
        priceId: priceId,
        BookingType: componentName,
        storeCustomerId: storeCustomerId,
      },
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Book New Order
              </p>
            </div>
            <div className="flex justify-content-center align-items-center mr-6">
              <div
                className="active-package-button flex-1 cursor-pointer"
                onClick={() => setCustomerPackagesModalVisible(true)}
              >
                <span className="shine" />
                Active Packages
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="flex-1 h-full"
        style={{
          pointerEvents: defaultPriceData.length === 0 ? "none" : "auto",
        }}
      >
        <div className="flex-1 my-3">
          <div
            className="flex-1 flex flex-row justify-content-around align-items-center mt-6"
            onClick={() => {
              if (packageData.length > 0) {
                handleSelectYourPackage();
              } else {
                setPriceCodeModalVisible(true);
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="flex-1 flex align-self-center justify-content-center">
              <img
                src={"VectorsLaundryApp/3.png"}
                style={{
                  alignSelf: "center",
                  transform: [{ scaleX: -1 }],
                  resizeMode: "contain",
                  width: height < 600 ? 140 : 180,
                  height: height < 600 ? 190 : 230,
                }}
              />
            </div>
            <div className="flex flex-1 align-center flex-column">
              <img
                src={"Laundy_App_Icons_Gifs/Packages_GIFs/Package_499.gif"}
                style={{
                  width: height < 600 ? 90 : 120,
                  height: height < 600 ? 90 : 150,
                  alignSelf: "center",
                }}
              />

              <div className="mx-2 py-4">
                <p
                  className="text-4xl font-bold text-center "
                  style={{ color: "#2B70D7" }}
                >
                  Package Booking
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div
            className="flex-1 flex flex-row-reverse justify-content-around align-items-center mt-6"
            onClick={() => {
              if (defaultPriceData.length > 1 && enabledMultiPriceList) {
                handleSelectYourPriceList();
              } else if (defaultPriceData[0]?.price?.id) {
                bookOrderNow(defaultPriceData[0]?.price?.id, "GeneralBooking");
              } else {
                setPriceCodeModalVisible(true);
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="flex-1 flex align-self-center justify-content-center">
              <img
                src={"VectorsLaundryApp/11.png"}
                style={{
                  alignSelf: "center",
                  transform: [{ scaleX: -1 }],
                  resizeMode: "contain",
                  width: height < 600 ? 150 : 190,
                  height: height < 600 ? 190 : 230,
                }}
              />
            </div>
            <div className="flex flex-1 align-center flex-column">
              <img
                src={"Laundy_App_Icons_Gifs/Packages_GIFs/ezgif.gif"}
                style={{
                  width: height < 600 ? 100 : 130,
                  height: height < 600 ? 110 : 160,
                  alignSelf: "center",
                }}
              />
              <div className="mx-2 py-4">
                <p
                  className="text-4xl font-bold text-center "
                  style={{ color: "#2B70D7" }}
                >
                  General Booking
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <PackageBookingPackageSelection
          setPackageBookingModalVisible={setPackageBookingModalVisible}
          packageBookingModalVisible={packageBookingModalVisible}
          packageData={packageData}
          sendDataToBookNewOrderPage={receiveSelectedPackageData}
          storeCarryForward={storeCarryForward}
          brandCarryForward={brandCarryForward}
        />
        <GeneralBookingPriceListSelection
          setGeneralBookingPriceListModalVisible={
            setGeneralBookingPriceListModalVisible
          }
          generalBookingPriceListModalVisible={
            generalBookingPriceListModalVisible
          }
          priceData={defaultPriceData}
          sendDataToBookNewOrderPage={receiveSelectedPriceListData}
        />
        <PriceCodeNotFound
          setPriceCodeModalVisible={setPriceCodeModalVisible}
          priceCodeModalVisible={priceCodeModalVisible}
        />
        {customerPackagesModalVisible && (
                  <CustomerPackagesModal
                    customerPackagesModalVisible={customerPackagesModalVisible}
                    setCustomerPackagesModalVisible={setCustomerPackagesModalVisible}
                    storeId={storeId}
                    storeCustomerId={storeCustomerId}
                    brandId={brandId}
                    // storeLoadData={storeLoadData}
                    brandCarryForwardApplyOn={brandCarryForwardApplyOn}
                  />
                )}
      </div>
    </div>
  );
};

export default BookNewOrder;
